__turbopack_context__.v({
  "extendBackgroundAbove": "AboutUsModule-module__-h2B2G__extendBackgroundAbove",
  "extendBackgroundBelow": "AboutUsModule-module__-h2B2G__extendBackgroundBelow",
  "module": "AboutUsModule-module__-h2B2G__module",
  "moduleBackground__ecoGreenGradient": "AboutUsModule-module__-h2B2G__moduleBackground__ecoGreenGradient",
  "moduleBackground__grey": "AboutUsModule-module__-h2B2G__moduleBackground__grey",
  "moduleBackground__redPastel": "AboutUsModule-module__-h2B2G__moduleBackground__redPastel",
  "moduleBackground__tealGradient": "AboutUsModule-module__-h2B2G__moduleBackground__tealGradient",
  "moduleBackground__tealSolid": "AboutUsModule-module__-h2B2G__moduleBackground__tealSolid",
  "moduleBackground__white": "AboutUsModule-module__-h2B2G__moduleBackground__white",
  "withNoPadding": "AboutUsModule-module__-h2B2G__withNoPadding",
  "withNoTopPadding": "AboutUsModule-module__-h2B2G__withNoTopPadding",
  "withPadding": "AboutUsModule-module__-h2B2G__withPadding",
  "withReducedPadding": "AboutUsModule-module__-h2B2G__withReducedPadding",
});
